import React, { useState, useEffect, ReactNode } from "react";
import useNetwork from "./useNetwork";
import Notification from "../shared/TemporaryNotification";
import { useTranslation } from "react-i18next";

interface Props {
  children: ReactNode;
}

export default function NetworkConnectionDetector({ children }: Props) {
  const { t } = useTranslation();
  const { isOnline } = useNetwork();
  const [
    showNotificationDisconnected,
    setShowNotificationDisconnected,
  ] = useState(false);

  useEffect(() => {
    setShowNotificationDisconnected(!isOnline);
  }, [isOnline]);

  return (
    <>
      {showNotificationDisconnected && (
        <Notification
          message={t("app.disconnected")}
          handleClose={() => setShowNotificationDisconnected(false)}
        />
      )}
      {children}
    </>
  );
}
